<template>
    <main class="mt-5">
        <span id="add-btn" class="not-in-print">
            <button :disabled="hasPermission('change_store_balance') ? false : true" type="button" tabindex="-1"
                class="btn btn-success" @click="incrementModal()">
                افزایش
            </button>
            <button :disabled="hasPermission('change_store_balance') ? false : true" type="button" tabindex="-1"
                class="btn btn-danger mr-2" @click="decrementModal()">
                کاهش
            </button>
            <router-link
                to="/admin/multi-update-store-items"
                :disabled="hasPermission('change_store_balance') ? false : true"
                class="btn btn-success mr-2"
                >افزایش دسته جمعی تنوع ها</router-link
            >
        </span>
        <b-tooltip v-if="!hasPermission('change_store_balance')" target="add-btn" triggers="hover">
            شما به این بخش دسترسی ندارید
        </b-tooltip>
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">انبار</h5>
                <div style="flex:1"></div>
                <button @click="print" class="btn btn-primary">
                    <span
                        style="transform: translateY(3px)"
                        class="feather-printer"
                    ></span>
                </button>
            </div>
            <b-card class="not-in-print">
                <div class="row mt-2">
                    <b-form-group class="col-5">
                        <multiselect
                            placeholder="انتخاب انبار"
                            v-model="selectedStore"
                            open-direction="bottom"
                            :options="stores"
                            label="label"
                            track-by="id"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :disabled="disabled"
                        >
                            <template slot="noOptions"> موردی یافت نشد </template>
                            <template slot="noResult"> موردی یافت نشد </template>
                        </multiselect>
                    </b-form-group>
                    <ProductSearch class="col-md-12 row" :selectable="true" :disabled="disabled"
                                @selectProduct="selectProduct" :store="selectedStore" @selectVariety="selectVariety" />
                    <b-form-group class="col-md-4">
                        <multiselect placeholder="نوع تغییرات" v-model="filter.type" open-direction="bottom"
                            :options="typeOptions" label="title" track-by="value" :searchable="true"
                            :close-on-select="true" :show-labels="false" :disabled="disabled">
                            <template slot="noOptions">
                                موردی یافت نشد
                            </template>
                            <template slot="noResult">
                                موردی یافت نشد
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group class="col-md-4">
                        <date-picker placeholder="از تاریخ" v-model="filter.start_date" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" />
                    </b-form-group>
                    <b-form-group class="col-md-4">
                        <date-picker ref="endPicker" placeholder="تا تاریخ" v-model="filter.end_date" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" />
                    </b-form-group>
                    <b-form-group class="col-md-3">
                        <div class="d-flex">
                        <label @click="() => filter.isHidden = filter.isHidden ? 0 : 1"
                                class="ml-2">تراکنش های قبل انبار گردانی</label>
                        <b-form-checkbox :unchecked-value="0"
                                        :disabled="disabled"
                                        :value="1"
                                        v-model="filter.isHidden"
                        />
                        </div>
                    </b-form-group>
                </div>
                <div class="text-center mt-1">
                    <button :disabled="disabled" @click="doFilter"  class="btn btn-primary px-5">جستجو</button>
                    <button  
                        :disabled="disabled"  
                        type="reset"  
                        @click="resetFilters"  
                        class="btn btn-warning px-5 mr-3"  
                    >  
                        برداشتن فیلتر  
                    </button>  
                </div>
            </b-card>
            <div class="card-body" id="print">
                <div>
                    <b-table v-if="items && items.data.length" responsive hover bordered :items="items.data" :fields="fields">
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate}}
                        </template>
                        <template v-slot:cell(admin_name)="data">
                            <span v-if="data.item.admin">{{data.item.admin.name}}</span>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:cell(store_name)="data">
                            {{data.item.store.label}}
                        </template>
                        <template v-slot:cell(product)="data">
                            {{data.item.store_item.variety.full_title}}
                        </template>
                        <template v-slot:cell(type)="data">
                            <span v-if="data.item.type == 'increment'" class="badge badge-success status">افزایش</span>
                            <span v-else class="badge badge-danger status">کاهش</span>
                        </template>
                    </b-table>
                    <div v-else class="alert alert-danger">
                        موردی یافت نشد
                    </div>
                    <Loading v-if="$root.isEmptyObject(items)" />
                    <!-- <pagination class="not-in-print" v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                        @pagination-change-page="changePage">
                    </pagination> -->
                </div>
            </div>
            <pagination v-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                @pagination-change-page="changePage">
            </pagination>
        </div>
        <StoreModal :stores="stores" :mode="mode" v-model="store" @dataSubmitted="handleDataSubmitted"/>  
    </main>
</template>
<script>
import StoreImpl from '@@/core/pages/Store/StoreImpl'
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
export default {
    components: {ProductSearch},
    extends: StoreImpl
}
</script>

<style>
@media print {
    .not-in-print {
        display: none !important;
    }
    
    .app-content .side-app {
        padding: 0 !important;
    }

    .print-only {
        display: flex;
        justify-content: center; 
    }

    body * {
        visibility: hidden;
    }
    #print,
    #print * {
        visibility: visible;
        font-size: 1.25rem;
    }
    #print {
        padding: 0 !important;
    }
    #print {
        width: 100%;
    }

    #print .not-in-print {
        display: none;
    }

    .mr-2-print {
        margin-right: 20px;
    }
}
</style>